import { lazyRetry } from '~/utils/lazyRetry'
import { ADMIN_ROUTES, COMMENT_ROUTES } from '~/constants/router'

import { adminRoles } from '~/modules/auth/conditions'

const CommentList = lazyRetry(() => import('~/pages/Comment/List'))
const CommentForm = lazyRetry(() => import('~/pages/Comment/Form'))

import { Comments } from '~/pages/Settings/Comments'

const CommentRouters = [
  {
    path: `${ADMIN_ROUTES.STORE}${COMMENT_ROUTES.COMMENTS}`,
    component: CommentList,
    layout: 'admin',
    exact: true,
    roles: adminRoles,
    routeName: 'Comments List',
  },
  {
    path: `${ADMIN_ROUTES.STORE}${COMMENT_ROUTES.EDIT}`,
    component: CommentForm,
    layout: 'admin',
    exact: true,
    roles: adminRoles,
    xProps: {
      isEditing: true,
    },
    routeName: 'Comment Edit',
  },
  {
    path: `${ADMIN_ROUTES.STORE}${ADMIN_ROUTES.SETTINGS}/comments`,
    component: Comments,
    layout: 'admin',
    exact: true,
    routeName: 'Setting - Comments',
    bsTheme: true,
    roles: adminRoles,
  },
]

export default CommentRouters
